import {Box, Container, Hidden, makeStyles} from '@material-ui/core';
import {ButtonPurple} from 'components/Buttons';
import Typo from 'components/Typo';
import React from 'react';
import {Helmet} from 'react-helmet';
import {useHistory} from 'react-router-dom';
import Footer from 'screens/common/Footer';
import {rieltor} from 'styles/theme';
import {createDashboardUrl} from 'utils/navigation';
import {HeaderFallback} from './HeaderFallback';

const useWhiteScreenStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down('xs')]: {
      paddingBottom: theme.spacing(6),
    },
  },
  content: {
    minHeight: 'calc(80vh - 160px)', // 100 % - header height
    overflow: 'hidden',
    position: 'relative',
  },
  newBg: {
    backgroundColor: rieltor.grayLines,
  },
  mainContainer: {
    display: 'flex',
    flexFlow: 'column nowrap',
    padding: '16px',
  },
  fallbackWrapper: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    rowGap: '20px',
  },
  backButton: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '245px',
    height: '52px',
    fontSize: '20px',
    backgroundColor: rieltor.purple,
    border: '1px solid transparent',
    borderRadius: '8px',
    color: '#fff',
    textDecoration: 'none !important',
    padding: '8px 14px',
    fontFamily: rieltor.fontFamily,
    fontWeight: 700,
    '&:hover': {
      backgroundColor: 'transparent',
      borderColor: rieltor.purple,
      color: rieltor.purple,
    },
  }
}));

interface WhiteScreenFallbackProps {
  onClose: () => void;
}

export const WhiteScreenFallback = ({
  onClose
}: WhiteScreenFallbackProps) => {
  const classes = useWhiteScreenStyles();

  return (
    <Box className={classes.root}>
      <HeaderFallback/>
      <Box className={`${classes.content}`}>
        <WhiteScreenBody onClose={onClose}/>
      </Box>

      <Hidden xsDown>
        <Footer/>
      </Hidden>
    </Box>
  );
};

const WhiteScreenBody = ({
  onClose
}: WhiteScreenFallbackProps) => {
  const classes = useWhiteScreenStyles();
  const history = useHistory();

  return (
    <>
      <Helmet>
        <title>Помилка</title>
      </Helmet>
      <Container maxWidth="xl" className={classes.mainContainer}>
        <div className={classes.fallbackWrapper}>
          <img
            src={require('./bot.png')}
            alt={'404 bot'}
            style={{height: 150, width: 150, marginBottom: 45}}
          />

          <Typo variant={'title0'} style={{fontSize: 30}}>
            Щось пішло не так
          </Typo>

          <Typo variant={'title2'} style={{fontWeight: 500, lineHeight: '30px', textAlign: 'center'}}>
            Ця сторінка недоступна або стала неактуальною.<br/>
            Спробуйте повернутись на головну сторінку кабінету
          </Typo>

          <ButtonPurple
            className={classes.backButton}
            onClick={() => {
              onClose();
              history.replace(createDashboardUrl({}));
            }}
          >
            На головну
          </ButtonPurple>
        </div>
      </Container>
    </>
  );
};
